// Resolve the VAT percentage to apply, honouring an explicit 0 (a non-UK school pays 0%
// VAT). A plain `values.VatPercentApplied || 20` treats the numeric 0 as falsy and wrongly
// charges 20%, so callers must go through this guard: it falls back only when the value is
// genuinely absent (blank/null/undefined) or unparseable, never when it is a real 0.
export const resolveVatPercent = (value, fallback = 20) => {
  if (value === '' || value === null || value === undefined) return fallback;
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? fallback : parsed;
};
